import SvgIcon, { SvgIconProps } from "@mui/material/SvgIcon";

export function Import(props: SvgIconProps) {
  return (
    <SvgIcon {...props}>
      <path d="M11 1h2v9h3l-4 4-4-4h3V1zM6 22h12a2 2 0 002-2V8a2 2 0 00-2-2h-3v2h3v12H6V8h3V6H6a2 2 0 00-2 2v12a2 2 0 002 2z" />
    </SvgIcon>
  );
}
